import { render, staticRenderFns } from "./AddCategoryPage.vue?vue&type=template&id=64ebbd86&scoped=true&"
import script from "./AddCategoryPage.vue?vue&type=script&lang=js&"
export * from "./AddCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryPage.vue?vue&type=style&index=0&id=64ebbd86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ebbd86",
  null
  
)

export default component.exports